import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyVideos = (
  data: IPropertyDetailsResponse
): string[] => {
  return data?.videos?.map(video => video.path.split("=").pop() || "") || [];
};

export type IPropertyDetailVideos = string[];
